import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
	topbarTheme = 'dark';

	menuTheme = 'dark';

	layoutMode = 'light';

	menuMode = 'static';

	isRTL = false;

	inputStyle = 'outlined';

	ripple: boolean;
	

	constructor(private primengConfig: PrimeNGConfig) {
		
	}

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.primengConfig.setTranslation(
			{
				dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
				dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
				dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
				monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
				monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
				today: 'Hoy',
				clear: 'Limpiar',
			}
		);
	}
}
